module.exports = __webpack_public_path__ + "static/media/temp_w_domu_ok_1.a335faac.svg";